import React from 'react';

const ContactPage: React.FC = () => {
    return (
        <div>
            <h1>Hello world!</h1>
            <p>THis is the contact page of our application.</p>
        </div>
    )
}

export default ContactPage;
